'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

/**
 * 折叠和展开动画效果
 */
var transition = {
  beforeEnter: function beforeEnter(ele) {
    ele.style.height = '0';
  },
  enter: function enter(ele) {
    ele.classList.add('collapse-transition');
    ele.style.height = ele.scrollHeight + 'px';
    ele.style.overflow = 'hidden';
  },
  afterEnter: function afterEnter(ele) {
    ele.classList.remove('collapse-transition');
    ele.style.height = '';
    ele.style.overflow = '';
  },
  beforeLeave: function beforeLeave(ele) {
    ele.style.height = ele.scrollHeight + 'px';
  },
  leave: function leave(ele) {
    if (ele.scrollHeight > 0) {
      // for excute ele.scrollHeight, without this chrome will jump to zero height suddenly, weired
      ele.classList.add('collapse-transition');
      ele.style.height = '0';
      ele.style.overflow = 'hidden';
    }
  },
  afterLeave: function afterLeave(ele) {
    ele.classList.remove('collapse-transition');
    ele.style.height = '';
    ele.style.overflow = '';
  }
};
var index = utils.create({
  name: 'collapse-transition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;
    var data = {
      on: transition
    };
    return h('transition', data, children);
  }
});

exports.default = index;
